import { BaseEnvironment } from '@shared/tokens/environment.token';

export const environment: BaseEnvironment = new BaseEnvironment({
  idpServerUrl: 'https://immo-smith-api-idp-qa.jad-sandbox.com/',
  loginClientId: 'b58a5a78-7abb-4ecb-bc58-353eba5219e7',
  serverUrl: 'https://immo-smith-api-platform-qa.jad-sandbox.com/api/',
  websiteUrl: 'https://immo-smith-webapp-platform-qa.jad-sandbox.com/',
  websiteServerUrl: 'http://localhost:5001/api/',
  backofficeUrl: 'http://localhost:4201/',
  backofficeServerUrl: 'http://localhost:5001/api/',
  environmentName: 'QA',
  recaptchaSiteKey: '6LeS63wqAAAAALQhIUhfW3Mv7yp48JhpgYi4LvJL',
  supportedLanguages: [
    { locale: 'de-DE', shortLocale: 'de', name: 'Deutsch' },
    { locale: 'en-US', shortLocale: 'en', name: 'English' }
  ],
  defaultLanguage: { locale: 'de-DE', shortLocale: 'de', name: 'Deutsch' },
  applicationName: 'backoffice',
   trackingSmith: {
    appVersion: '0.0.1',
    trackingId: 'ts_xxx',
    apiUrl: 'XXX',
  }
});
